module.exports = __webpack_public_path__ + "img/first-page.cf4e6619.png";